import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';
import 'select2';

export default class extends Controller {
  // Use kebab-case for target names in Stimulus
  static targets = ['typeSelect', 'objectSelect', 'linkFields', 'linkText', 'linkUrl'];

  initialize() {
    // Debug helper
    console.log('RelatedEntities controller initialized');
    console.log('Has type select:', this.hasTypeSelectTarget);
  }

  connect() {
    // Debug info
    console.log('RelatedEntities controller connected');
    console.log('Element:', this.element);
    console.log('Type select exists:', this.hasTypeSelectTarget);
    
    if (this.hasTypeSelectTarget) {
      console.log('Type select found:', this.typeSelectTarget);
    } else {
      console.log('Looking for select with data-related-entities-target="typeSelect"');
      const manualFind = this.element.querySelector('[data-related-entities-target="typeSelect"]');
      console.log('Manual find result:', manualFind);
    }

    // Initialize select2 on type select if found
    if (this.hasTypeSelectTarget) {
      const $typeSelect = $(this.typeSelectTarget);
      
      // Initialize select2
      $typeSelect.select2({
        placeholder: 'Select type',
        width: '100%',
        minimumResultsForSearch: 0,
        allowClear: false
      });

      // Bind change events
      $typeSelect.on('change', () => {
        console.log('Type select changed:', this.typeSelectTarget.value);
        this.onTypeChange();
      });
    }

    // Initialize select2 on all object selects
    if (this.hasObjectSelectTargets) {
      this.objectSelectTargets.forEach((el) => {
        $(el).select2({
          placeholder: 'Select item',
          width: '100%',
          allowClear: true
        });
      });
    }

    // Apply initial visibility state
    this.applyVisibility();
  }

  disconnect() {
    // Clean up select2 instances
    if (this.hasTypeSelectTarget) {
      const $typeSelect = $(this.typeSelectTarget);
      if ($typeSelect.data('select2')) {
        $typeSelect.select2('destroy');
      }
    }

    if (this.hasObjectSelectTargets) {
      this.objectSelectTargets.forEach((el) => {
        const $el = $(el);
        if ($el.data('select2')) {
          $el.select2('destroy');
        }
      });
    }
  }

  onTypeChange() {
    console.log('Type changed, applying visibility');
    this.applyVisibility();
  }

  applyVisibility() {
    if (!this.hasTypeSelectTarget) {
      console.error('Type select target not found');
      return;
    }

    const selectElement = this.typeSelectTarget;
    
    // Get the selected option text to check if it's "Link"
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    const selectedText = selectedOption ? selectedOption.text.trim() : '';
    const selectedValue = selectElement.value || '';
    
    console.log('Selected value:', selectedValue, 'Selected text:', selectedText);
    
    // Check if Link is selected (empty value and Link text)
    const isLink = (selectedValue === '' && selectedText === 'Link');
    console.log('Is link?', isLink);

    // Hide all fields first
    this.hideAllObjectSelects();
    this.hideLinkFields();

    if (isLink) {
      // Link selected - show link fields, clear target fields
      console.log('Showing link fields');
      this.showLinkFields();
      this.clearAllTargetIds();
    } else if (selectedValue) {
      // Class selected - show corresponding object select
      console.log('Showing object select for type:', selectedValue);
      this.showObjectSelectForType(selectedValue);
      this.clearLinkFields();
    }
  }

  showObjectSelectForType(type) {
    // Find the wrapper with the matching data-related-type
    const selector = `.related-entity-object-wrapper[data-related-type="${type}"]`;
    const wrapper = this.element.querySelector(selector);
    
    console.log('Looking for wrapper:', selector);
    console.log('Found wrapper:', wrapper);
    
    if (wrapper) {
      // Show the wrapper
      wrapper.style.display = '';
      
      // Enable the select inside
      const select = wrapper.querySelector('.related-entity-object-select');
      if (select) {
        select.disabled = false;
        
        // Update select2 if initialized
        const $select = $(select);
        if ($select.data('select2')) {
          $select.prop('disabled', false).trigger('change');
        }
      }
    }
  }

  hideAllObjectSelects() {
    // Hide all object select wrappers
    const wrappers = this.element.querySelectorAll('.related-entity-object-wrapper');
    wrappers.forEach(wrapper => {
      wrapper.style.display = 'none';
      
      // Disable the select inside
      const select = wrapper.querySelector('.related-entity-object-select');
      if (select) {
        select.disabled = true;
        
        // Clear the value
        if (select.value) {
          select.value = '';
          
          // Update select2 if initialized
          const $select = $(select);
          if ($select.data('select2')) {
            $select.val(null).trigger('change');
          }
        }
      }
    });
  }

  clearAllTargetIds() {
    // Clear all target_id values
    if (this.hasObjectSelectTargets) {
      this.objectSelectTargets.forEach(select => {
        select.value = '';
        
        // Update select2 if initialized
        const $select = $(select);
        if ($select.data('select2')) {
          $select.val(null).trigger('change');
        }
      });
    }
  }

  showLinkFields() {
    if (this.hasLinkFieldsTarget) {
      // Show the link fields container
      this.linkFieldsTarget.style.display = '';
      
      // Enable link text field
      if (this.hasLinkTextTarget) {
        this.linkTextTarget.disabled = false;
        $(this.linkTextTarget).closest('.input').show();
      }
      
      // Enable link URL field
      if (this.hasLinkUrlTarget) {
        this.linkUrlTarget.disabled = false;
        $(this.linkUrlTarget).closest('.input').show();
      }
    }
  }

  hideLinkFields() {
    if (this.hasLinkFieldsTarget) {
      // Hide the link fields container
      this.linkFieldsTarget.style.display = 'none';
      
      // Disable and clear link text field
      if (this.hasLinkTextTarget) {
        this.linkTextTarget.disabled = true;
        this.linkTextTarget.value = '';
        $(this.linkTextTarget).closest('.input').hide();
      }
      
      // Disable and clear link URL field
      if (this.hasLinkUrlTarget) {
        this.linkUrlTarget.disabled = true;
        this.linkUrlTarget.value = '';
        $(this.linkUrlTarget).closest('.input').hide();
      }
    }
  }

  clearLinkFields() {
    // Clear link text field
    if (this.hasLinkTextTarget) {
      this.linkTextTarget.value = '';
    }
    
    // Clear link URL field
    if (this.hasLinkUrlTarget) {
      this.linkUrlTarget.value = '';
    }
  }
}